// 默认路由
const constantRoutes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index/index.vue'),
    meta: {},
  },
  {
    path: '/:all(.*)*',
    name: 'notFound',
    component: () => import('@/views/[...all].vue'),
    meta: {},
  },
  {
    path: '/customerService',
    name: 'customerService',
    component: () => import('@/views/customerService.vue'),
    meta: {},
  },
  {
    path: '/maintain',
    name: 'maintain',
    component: () => import('@/views/maintain.vue'),
    meta: {},
  },
]

export default [
  ...constantRoutes,
]
